import './Loader.css'

export default function Loader() {
  return (
      <div className="loader-continer">
        <div className="loader"></div>
    </div>
  )
}
